import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { cleanupCCB14Drp } from "../../../../../../api/CCB/DRP/terminationDisclosureDRP";
import { DRP_TYPES } from "../../../../../../api/helpers/constants";
import { FORM_ID } from "../../../../../../constants/Forms";
import { ccbActions, logoutActions } from "../../../../../../store/actions";
import {
  fetchCCB,
  postCCB,
  putCCB,
  putCCBStatus,
} from "../../../../../../store/middlewares";
import { loadingStatus } from "../../../../../../store/state";
import NavigationButtons from "../../../../../SharedComponents/NavigationButtons";
import LostDataModal from "../../../../../SharedComponents/LostDataModal";
import CustomCard from "../../common/CustomCard";
import DeleteModal from "../../common/DeleteModal";
import Toast from "../../common/Toast";
import {
  INTRO_REV,
  INTRO_TEXT,
  KEYS,
  RADIO,
  SECTION,
  TOAST_MESSAGE,
} from "../../constants";
import {
  getValues,
  isChecked,
  isEachChecked,
  isSomeChecked,
} from "../../helpers";
import { useClickOutside } from "../../hooks/useClickOutside";
import { headerText } from "../constants";
import { initialState, terminationDisclosure } from "../state";
import CustomSubCategoryCard from "./CustomSubCategoryCard";
import "./TerminationDisclosureForm.scss";

const TerminationDisclosureForm = ({
  toggleForm,
  oktaSubId,
  header,
  updateCCBForm,
  backFormId,
  nextFormId,
  updateCCB14CompletedInd,
  updateCCB14Step,
  termDiscl,
  termDRPList,
  isLoadingProp,
  setIsLoadingProp,
  setData,
  unchecked,
}) => {
  const dispatch = useDispatch();

  const toastRef = useRef(null);
  const containerRef = useRef(null);

  const { error, loading, isFirstLoad, data } = useSelector(
    (state) => state.ccb14
  );

  const [isPageChanged, setIsPageChanged] = useState(false);
  const [isShowDRPCleanupModal, setShowDRPCleanupModal] = useState(false);
  const [selectedSection, setSelectedSection] = useState(null);
  const [drpCleanupList, setDrpCleanupList] = useState(null);

  const isLoading = loading === loadingStatus.PENDING || isLoadingProp;
  let isError = error || loading === loadingStatus.FAILED;

  const [isRequired, setIsRequired] = useState(false);
  const [isCardOpen, setIsCardOpen] = useState({
    [SECTION.terminationDisclosures]: false,
  });
  const [showBackModal, setShowBackModal] = useState(false);
  const [showToast, setShowToast] = useState(false);

  const [isEdit, setIsEdit] = useState({
    [SECTION.terminationDisclosures]: false,
  });
  const [isSaved, setIsSaved] = useState({
    [SECTION.terminationDisclosures]: false,
  });

  const updateStatus = async (data) => {
    try {
      await dispatch(
        putCCBStatus({ oktaSubId, data: { terminationdisclstatus: data } })
      );
    } catch (err) {
      console.log(err);
    }
  };

  const valuesA = getValues(data, KEYS.terminationDisclosures);
  const isSaveDisabledA = isEachChecked(valuesA);

  const toggleLeftNav = () => {
    //If all "No" values, update green checkmark on save. If not, keep as 1/2
    const isNo = (currentValue) => currentValue === false;
    const isYes = (currentValue) => currentValue === true;
    let isNoValues = valuesA.every(isNo);
    const isYesValues = valuesA.some(isYes);

    if (isNoValues) {
      updateCCB14CompletedInd({ termDisclosureCompleteInd: true });
      updateStatus(null);
    } else if (isYesValues) {
      updateCCB14Step({ termDisclosureCompleteStep: "1/2" });
      updateCCB14CompletedInd({ termDisclosureCompleteInd: false });
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);

    return () => {
      window.scrollTo(0, 0);
    };
  }, []);

  useEffect(() => {
    try {
      const initData = async () => {
        const { payload } = await dispatch(fetchCCB(oktaSubId));

        if (payload) {
          const valuesA = getValues(payload, KEYS.terminationDisclosures);
          const a = valuesA.some(isChecked);

          setIsSaved({
            [SECTION.terminationDisclosures]: a,
          });

          setIsEdit({
            [SECTION.terminationDisclosures]: !a,
          });

          if (!a) {
            setIsCardOpen((prevState) => ({
              ...prevState,
              [SECTION.terminationDisclosures]: true,
            }));
          }

          if (a) {
            setIsCardOpen({ ...initialState });
          }
        } else {
          if (!isSaveDisabledA) {
            setIsCardOpen((prevState) => ({
              ...prevState,
              [SECTION.civilJudicialActions]: true,
            }));
          }
        }
      };

      const a = valuesA.some(isChecked);

      if (loading !== loadingStatus.SUCCEDED) {
        initData();
      } else {
        setIsSaved({
          [SECTION.terminationDisclosures]: a,
        });

        setIsEdit({
          [SECTION.terminationDisclosures]: !a,
        });

        if (!a) {
          setIsCardOpen((prevState) => ({
            ...prevState,
            [SECTION.terminationDisclosures]: true,
          }));
        }

        if (a) {
          setIsCardOpen({ ...initialState });
        }
      }
    } catch (error) {
      console.log({ error });
    }

    return () => {
      const a = valuesA.some(isChecked);

      setIsSaved({
        [SECTION.terminationDisclosures]: a,
      });

      setIsEdit({
        [SECTION.terminationDisclosures]: !a,
      });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isPageChanged]);

  const [formHasChanged, setFormHasChanged] = useState(false);

  useEffect(() => {
    if (formHasChanged) {
      dispatch(logoutActions.setShowLogoutModal({ showLogoutModal: true }));
    }
  }, [formHasChanged, dispatch]);

  const handleChangeChecked = (e) => {
    const { name, value } = e.target;
    let newValue = value;

    if (isSaved[SECTION.terminationDisclosures]) {
      updateCCB14Step({ termDisclosureCompleteStep: "1/2" });
      updateCCB14CompletedInd({ termDisclosureCompleteInd: false });
    }

    setFormHasChanged(true);

    switch (value) {
      case RADIO.yes:
        newValue = true;
        break;
      case RADIO.no:
        newValue = false;
        break;
      default:
        newValue = null;
        break;
    }

    dispatch(ccbActions.setChecked({ [name]: newValue }));
  };

  const handleOnEditClick = (section) => {
    setIsEdit((prevState) => ({ ...prevState, [section]: true }));
  };

  const closeCleanupModalHandler = async () => {
    setShowDRPCleanupModal(false);
  };

  const onCleanupModalHandler = async () => {
    if (selectedSection === null) {
      return;
    }
    setIsLoadingProp(true);

    await cleanupCCB14Drp({
      oktaSubId,
      drpTypeId: DRP_TYPES.Termination,
      data: {
        data: {
          termDiscl: unchecked,
        },
      },
    });

    setData();
    await handleOnSaveClick(selectedSection);
    setIsLoadingProp(false);
    setShowDRPCleanupModal(false);
  };

  const handleDeleteOnSave = async (section) => {
    handleCloseToast();
    setSelectedSection(section);

    let questionKeys = [];
    for (let i in termDiscl) {
      if (!questionKeys.includes(termDiscl[i].key)) {
        questionKeys.push(termDiscl[i].key);
      }
    }

    let deleteKeys = [];
    for (let i in termDRPList) {
      for (let j in termDRPList[i].terminationdrp.drpList) {
        if (!questionKeys.includes(termDRPList[i].terminationdrp.drpList[j])) {
          deleteKeys.push({
            qkey: termDRPList[i].terminationdrp.drpList[j],
            isDraft: "No",
            types: [termDRPList[i].terminationdrp.termType] || [],
            date: [termDRPList[i].terminationdrp.termDate] || [],
            dataIndex: termDRPList[i].ccbdrpid,
          });
        }
      }
    }

    if (deleteKeys.length > 0) {
      setDrpCleanupList(deleteKeys);
      setShowDRPCleanupModal(true);
    } else {
      handleOnSaveClick(section);
    }
  };

  const handleOnSaveClick = async (section) => {
    if (isSaveDisabledA && section === SECTION.terminationDisclosures) {
      setIsCardOpen((prevState) => ({
        ...prevState,
        [SECTION.terminationDisclosures]: true,
      }));
    }

    setFormHasChanged(false);

    setIsCardOpen((prevState) => ({ ...prevState, [section]: false }));

    if (isFirstLoad) {
      try {
        await dispatch(postCCB({ oktaSubId, data }));
      } catch (err) {
        console.log(err);
        isError = `${err}`;
      }

      setIsSaved((prevState) => ({ ...prevState, [section]: true }));
    } else {
      try {
        await dispatch(putCCB({ oktaSubId, data }));
      } catch (err) {
        console.log(err);
        isError = `${err}`;
      }

      setIsSaved((prevState) => ({ ...prevState, [section]: true }));
    }

    toggleLeftNav();
    setIsEdit((prevState) => ({ ...prevState, [section]: false }));
    setIsCardOpen({
      [SECTION.terminationDisclosures]: false,
    });

    setShowToast(true);

    window.scrollTo(0, 0);
  };

  const handleCloseToast = () => setShowToast(false);

  useEffect(() => {
    let handler = (e) => {
      if (!toastRef?.current?.contains(e.target)) {
        handleCloseToast();
      }
    };

    document.addEventListener("mousedown", handler);

    return () => {
      document.removeEventListener("mousedown", handler);
    };
  });

  const handleCloseBackModal = () => setShowBackModal(false);

  const cleanup = (isFetch = false) => {
    dispatch(ccbActions.setChecked({ ...initialState }));
    setIsRequired(false);
    handleCloseToast();
    setFormHasChanged(false);
    setIsCardOpen({
      [SECTION.terminationDisclosures]: false,
    });
    setIsEdit({ [SECTION.terminationDisclosures]: false });

    if (!isFetch) {
      setIsPageChanged((prev) => !prev);
    }
  };

  const handleShowBackModal = () => {
    if (
      ((isSomeChecked(valuesA) && isEdit[SECTION.terminationDisclosures]) ||
        (isSomeChecked(valuesA) && !isSaved[SECTION.terminationDisclosures])) &&
      formHasChanged
    ) {
      setShowBackModal(true);
    } else {
      dispatch(ccbActions.setIsBack(true));
      toggleForm(backFormId);
      setIsPageChanged((prev) => !prev);
    }
  };

  const handleBackClick = async () => {
    cleanup();
    toggleForm(backFormId);

    if (isSaved[SECTION.terminationDisclosures]) {
      updateCCB14CompletedInd({ termDisclosureCompleteInd: true });
    }

    dispatch(ccbActions.setIsBack(true));
    dispatch(logoutActions.setShowLogoutModal({ showLogoutModal: false }));
    handleCloseBackModal();
  };

  const handleNext = async () => {
    dispatch(ccbActions.setIsBack(false));
    cleanup(true);
    dispatch(logoutActions.setShowLogoutModal({ showLogoutModal: false }));

    const isYes = (currentValue) => currentValue === true;
    let isYesValues = valuesA.some(isYes);

    if (loading === loadingStatus.IDLE || loading === loadingStatus.SUCCEDED) {
      const { payload } = await dispatch(fetchCCB(oktaSubId));

      isYesValues = getValues(payload, KEYS.terminationDisclosures).some(isYes);
    }

    if (isYesValues) {
      updateCCBForm(nextFormId);
    } else {
      updateCCB14CompletedInd({ termDisclosureCompleteInd: true });
      toggleForm(FORM_ID.FINANCIAL_DISCLOSURE);
    }
  };

  const renderSubcategory = (category, section) => {
    const disabledSave =
      (isSaved[SECTION.terminationDisclosures] &&
        !isEdit[SECTION.terminationDisclosures] &&
        section === SECTION.terminationDisclosures) ||
      (!isSaveDisabledA && section === SECTION.terminationDisclosures);

    return (
      <CustomSubCategoryCard
        data={data}
        category={category}
        handleOnEditClick={handleOnEditClick}
        handleChangeChecked={handleChangeChecked}
        handleOnSaveClick={handleDeleteOnSave}
        section={section}
        isSaved={isSaved}
        isLoading={isLoading}
        isRequired={isRequired}
        disabledSave={disabledSave}
        ref={containerRef}
      />
    );
  };

  useClickOutside(toastRef, containerRef, showToast, handleCloseToast);

  return (
    <div className="termination-disclosures-wrapper" ref={containerRef}>
      <Toast
        showToast={showToast}
        closeToast={handleCloseToast}
        text={TOAST_MESSAGE}
        ref={toastRef}
      />

      <div className="row">
        <div className="col-md-12">
          <div className="eyebrow">
            <strong id={`eyebrow-ccb-${header}`}>
              Character, Credit, and Bonding
            </strong>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-md-12">
          <h1 id={`ccb_header_termDiscl`}>{header}</h1>
          <h2 id={`ccb_intro_rev_termDiscl`} style={{ color: "black" }}>
            {INTRO_REV}
          </h2>
        </div>
      </div>

      <div className="row">
        <div className="col-md-12">
          <p id="ccb_intro_text_termDiscl">{INTRO_TEXT}</p>
        </div>
      </div>

      <div className="row">
        <div className="col-md-12">
          <CustomCard
            isOpen={isCardOpen[SECTION.terminationDisclosures]}
            setIsOpen={setIsCardOpen}
            headerText={headerText.TERM_DISCL}
            isCompleted={isSaved[SECTION.terminationDisclosures]}
            index={SECTION.terminationDisclosures}
          >
            {renderSubcategory(
              terminationDisclosure(
                isSaved[SECTION.terminationDisclosures] &&
                  !isEdit[SECTION.terminationDisclosures]
              ),
              SECTION.terminationDisclosures
            )}
          </CustomCard>
        </div>
      </div>
      <NavigationButtons
        onBack={handleShowBackModal}
        onNext={handleNext}
        nxtbtnid={"terDisNext"}
        bckbtnid={"terDisBack"}
        isLoading={isLoading}
        isDisabled={
          !isSaved[SECTION.terminationDisclosures] || !!isError || isLoading
        }
      />

      {isShowDRPCleanupModal && (
        <DeleteModal
          isOpen={isShowDRPCleanupModal}
          showSpinner={false}
          isDRP
          type={headerText.HEADER}
          list={drpCleanupList}
          description="You had previously provided a DRP(s) associated with this
          question. Changing your response will delete the following
          DRP(s). Are you sure you want to proceed?"
          message="Are You Sure You Want To Proceed?"
          closeClick={closeCleanupModalHandler}
          deleteClick={onCleanupModalHandler}
        />
      )}

      <LostDataModal
        isOpen={showBackModal}
        handleClose={handleCloseBackModal}
        handleProceed={handleBackClick}
      />
    </div>
  );
};

export default TerminationDisclosureForm;
